import React from "react";
const FlagEN = () => (
    <svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1877_5699)">
            <path d="M28 0H0V18.9933H28V0Z" fill="#F5F5F5" />
            <path d="M28 0H0V2.79732H28V0Z" fill="#FF0000" />
            <path d="M28 5.40186H0V8.19918H28V5.40186Z" fill="#FF0000" />
            <path d="M28 10.8022H0V13.5996H28V10.8022Z" fill="#FF0000" />
            <path d="M28 16.2046H0V19.0019H28V16.2046Z" fill="#FF0000" />
            <path d="M13.0929 0H0V10.8023H13.0929V0Z" fill="#0000FF" />
            <path
                d="M2.3464 1.22266L2.71023 1.97307L3.52514 2.09368L2.93577 2.67994L3.07571 3.50574L2.3464 3.11545L1.6171 3.50574L1.75703 2.67994L1.16602 2.09368L1.98093 1.97307L2.3464 1.22266Z"
                fill="#F5F5F5"
            />
            <path
                d="M4.3005 4.13867L4.66433 4.89077L5.47924 5.01137L4.88987 5.59596L5.02981 6.42175L4.3005 6.03147L3.5712 6.42175L3.71113 5.59596L3.12012 5.01137L3.93503 4.89077L4.3005 4.13867Z"
                fill="#F5F5F5"
            />
            <path
                d="M8.86691 4.13916L9.23074 4.89125L10.0456 5.01186L9.45628 5.59645L9.59621 6.42224L8.86691 6.03196L8.13761 6.42224L8.27754 5.59645L7.68652 5.01186L8.50143 4.89125L8.86691 4.13916Z"
                fill="#F5F5F5"
            />
            <path
                d="M6.58346 1.22266L6.94729 1.97307L7.7622 2.09368L7.17283 2.67994L7.31277 3.50574L6.58346 3.11545L5.85416 3.50574L5.99409 2.67994L5.40308 2.09368L6.21799 1.97307L6.58346 1.22266Z"
                fill="#F5F5F5"
            />
            <path
                d="M10.821 1.22266L11.1848 1.97307L11.9997 2.09368L11.4104 2.67994L11.5503 3.50574L10.821 3.11545L10.0917 3.50574L10.2316 2.67994L9.64062 2.09368L10.4555 1.97307L10.821 1.22266Z"
                fill="#F5F5F5"
            />
            <path
                d="M2.3464 7.05664L2.71023 7.80873L3.52514 7.92766L2.93577 8.51393L3.07571 9.33972L2.3464 8.94944L1.6171 9.33972L1.75703 8.51393L1.16602 7.92766L1.98093 7.80873L2.3464 7.05664Z"
                fill="#F5F5F5"
            />
            <path
                d="M6.58346 7.05713L6.94729 7.80922L7.7622 7.92815L7.17283 8.51442L7.31277 9.34021L6.58346 8.94993L5.85416 9.34021L5.99409 8.51442L5.40308 7.92815L6.21799 7.80922L6.58346 7.05713Z"
                fill="#F5F5F5"
            />
            <path
                d="M10.821 7.05713L11.1848 7.80922L11.9997 7.92815L11.4104 8.51442L11.5503 9.34021L10.821 8.94993L10.0917 9.34021L10.2316 8.51442L9.64062 7.92815L10.4555 7.80922L10.821 7.05713Z"
                fill="#F5F5F5"
            />
        </g>
        <defs>
            <clipPath id="clip0_1877_5699">
                <rect width="28" height="19" rx="2" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default FlagEN;
